import React from "react";
import { barsIcon, searchIcon, targetIcon } from "./icons";
import { FollowUpTable } from "./ExtraInfo";
import { hasFollowUp } from "./minorAilmentVerticalConditions";

const Card = ({ icon, title, items }) => (
  <div className="bg-teal-25 rounded-xl p-5 relative">
    <div className="flex gap-4">
      <div className="flex-shrink-0 min-h-[86px]">{icon}</div>

      <div>
        <p className="font-bold text-[16px] text-teal-300 mb-2">{title}</p>

        <ul className="mt-[16px] font-medium ml-[8px] space-y-[11px]">
          {items.map((item, i) => (
            <li
              key={i}
              className="pl-[8px] text-gray-600 relative text-[16px]"
            >
              <span className="absolute -left-[8px] text-REELTeal flex items-center justify-center min-h-[16px]">
                <svg
                  width="8px"
                  height="8px"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="2.5" cy="3" r="2" stroke="#017E9D" />
                </svg>
              </span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

const Dot = ({ className }) => (
  <div className={`absolute ${className}`}>
    <div className="w-[18px] h-[18px] rounded-full border-2 border-REELTeal bg-white flex items-center justify-center">
      <div className="w-[6px] h-[6px] rounded-full bg-REELTeal" />
    </div>
  </div>
);

export default function MinorAilmentInfoVertical({
  minorAilmentName = "Allergic Rhinitis",
  documentation,
  education,
  treatment,
  goals
}) {

  const cards = [
    {
      icon: searchIcon,
      title: `What is ${minorAilmentName}`,
      items: [
        "An inflammation of the upper respiratory tract (includes inside of the nose)",
        "This can be caused by allergens such as pollen, mold, dust, and pets",
      ],
    },
    {
      icon: barsIcon,
      title: "Goals",
      items: [
        "Provide Relief",
        "Prevent exposure to allergens",
        "Minimize side effects of treatment",
        "Improve quality of life",
      ],
    },
    {
      icon: targetIcon,
      title: "Tips",
      items: [
        "Keep windows closed; use air conditioning",
        "Use a dehumidifier",
        "Keep pets out of the bedroom",
        "Do not keep plants in the house",
        "Avoid tobacco smoke, insect sprays, paint",
      ],
    },
  ];

  return (
    <div className="w-full max-w-[700px] mx-auto">
      <div className="relative py-8">
        <div className="absolute inset-[0.10in]">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 520 554"
            preserveAspectRatio="none"
            className="pointer-events-none"
          >
            <path
              d="M0 1H369.956C376.601 1 381.98 6.3993 381.956 13.0438L381.44 154.443C381.416 161.053 376.051 166.399 369.44 166.399H161.885C155.228 166.399 149.843 171.818 149.885 178.475L150.412 262.068V343.395C150.412 350.022 155.785 355.395 162.412 355.395H370C376.627 355.395 382 360.767 382 367.395V541C382 547.627 376.627 553 370 553H334.25H286.5H191H0"
              className="stroke-REELTeal"
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </div>

        <Dot className="-left-[8px] top-[2px]" />
        <Dot className="right-[180px] top-[110px]" />
        <Dot className="left-[198px] top-[340px]" />
        <Dot className="right-[180px] top-[580px]" />
        <Dot className="-left-[8px] bottom-[2px]" />

        {/* CARDS */}
        <div className="relative flex flex-col gap-12">

          <div className="w-[65%]">
            <Card {...cards[0]} />
          </div>

          <div className="w-[65%] ml-auto">
            <Card {...cards[1]} />
          </div>

          <div className="w-[65%]">
            <Card {...cards[2]} />
          </div>

        </div>
      </div>

      {(
        hasFollowUp(documentation, treatment) ||
        (education &&
          (education.followUpDate ||
            education.followUp ||
            (Array.isArray(education.vaccineSchedule) &&
              education.vaccineSchedule.length > 0)))
      ) && (
        <div className="mt-12">
          <FollowUpTable
            documentation={documentation}
            education={education}
            minorAilmentName={minorAilmentName}
            goals={goals}
            treatment={treatment}
          />
        </div>
      )}
    </div>
  );
}